var url = window.location.search;

if ( url.length > 0 ) {
  setTimeout(function(){
    var url = window.location.search;
    url = url.replace("?", '').toLowerCase();
    var element = document.getElementById(url);
    if (!element) {
      return;
    }
    element.click();
  }, 2000)
}

// Make subscription images clickable update
$(".subscription-block-container .slide-button").click(function() {
  $(this).parents('.subscription-block-container').find('.slide-button').removeClass('selected');
  $(this).parent().find('.slide-button').addClass('selected');

  
  if ($(this).hasClass('weekly')) {
    $('.bi-weekly-coffee').hide();
    $('.weekly-coffee').show();
  } else if ($(this).hasClass('bi-weekly')) {
    $('.bi-weekly-coffee').show();
    $('.weekly-coffee').hide();
  }

  const nextSection = $(this).closest('.subscription-section-wrapper').next();
  $(nextSection).slideDown('slow');
  const nextPos = nextSection.offset().top - 20;
  $('html, body').animate({
    scrollTop: nextPos,
  }, 600);
});
